import { usePostPortfolioBankProductMutation } from "web_myplann/Api/Portfolio/Mutations/usePostPortfolioBankProductMutation";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { getBankProductCreateFormDefaultValues } from "web_myplann/Portfolio/Forms/BankProductForm/bankProductFormDefaults";
import {
	type BankProductCreateFormOutput,
	getBankProductCreateFormSchema,
} from "web_myplann/Portfolio/Forms/BankProductForm/bankProductFormSchema";
import { mapInvestmentCreateFormToRequest } from "web_myplann/Portfolio/Forms/InvestmentForm/mapInvestmentFormToRequest";
import { useCreatePortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useCreatePortfolioForm";

export const useCreateBankProductForm = () => {
	const { t } = useResource();
	const { mutate, isPending } = usePostPortfolioBankProductMutation();

	const { form, onSubmit } = useCreatePortfolioForm({
		schema: getBankProductCreateFormSchema(t),
		defaultValues: getBankProductCreateFormDefaultValues(),
		mutate: (data: BankProductCreateFormOutput, options) => {
			mutate(mapInvestmentCreateFormToRequest(data), options);
		},
		successRoute: Routing.Portfolio.PortfolioAddBankProductSuccess.path(),
	});

	return { form, onSubmit, isPending };
};
